import { OPERATOR_SERVICE_QUALITY_STATS_MOCK } from './operator-service-quality.mock';
import { applyServiceQualityPeriod } from './operator-service-quality.period';
import type {
  DashboardPeriod,
  ServiceQualityStatsDto,
} from './operator-service-quality.types';

/**
 * Operator service-quality stats.
 *
 * Today: typed mock so the UI is wired like a real API consumer.
 * Later: replace `getStats` with fetch / generated client — keep the DTO
 * and pass `period` as a query param.
 */
export const OperatorServiceQualityService = {
  async getStats(
    _organizationId: string,
    period: DashboardPeriod,
  ): Promise<ServiceQualityStatsDto> {
    await new Promise((resolve) => setTimeout(resolve, 150));
    return applyServiceQualityPeriod(
      structuredClone(OPERATOR_SERVICE_QUALITY_STATS_MOCK),
      period,
    );
  },
};
